import { MERMAID_EDITOR_WIDGET, MermaidEditorWidget } from './editor/widget.js';
import {
  EdgelessMermaidRendererElement,
  MermaidRendererTag,
} from './renderer/dom-renderer.js';
import { EdgelessMermaidMenu } from './toolbar/mermaid-menu.js';
import { EdgelessMermaidToolButton } from './toolbar/mermaid-tool-button.js';

export function effects() {
  if (!customElements.get(MERMAID_EDITOR_WIDGET)) {
    customElements.define(MERMAID_EDITOR_WIDGET, MermaidEditorWidget);
  }
  customElements.define(MermaidRendererTag, EdgelessMermaidRendererElement);
  customElements.define('edgeless-mermaid-menu', EdgelessMermaidMenu);
  customElements.define(
    'edgeless-mermaid-tool-button',
    EdgelessMermaidToolButton
  );
}

declare global {
  interface HTMLElementTagNameMap {
    [MERMAID_EDITOR_WIDGET]: MermaidEditorWidget;
    'affine-edgeless-mermaid-renderer': EdgelessMermaidRendererElement;
    'edgeless-mermaid-menu': EdgelessMermaidMenu;
    'edgeless-mermaid-tool-button': EdgelessMermaidToolButton;
  }
}
